import type { TOC } from '@ember/component/template-only';
import type Patient from 'parog-web/models/patient';
import type { EmberChangeset } from 'ember-changeset';
import ProfessionalStatusDropdown from 'parog-web/components/lifestyle/edition/professional-status-dropdown';
import MaritalStatusDropdown from 'parog-web/components/lifestyle/edition/marital-status-dropdown';
import LifestyleDropdown from 'parog-web/components/lifestyle/edition/lifestyle-dropdown';
import LifestyleTextarea from 'parog-web/components/lifestyle/edition/lifestyle-textarea';

interface Signature {
  Args: {
    form: { changeset: EmberChangeset };
    patient: Patient;
  };
}

export default <template>
  <div class='field'>

    <ProfessionalStatusDropdown @changeset={{@form.changeset}} />

    {{#if @patient.isProIrc}}
      <MaritalStatusDropdown @changeset={{@form.changeset}} />
      <LifestyleDropdown @changeset={{@form.changeset}} />
      <LifestyleTextarea @changeset={{@form.changeset}} />

    {{/if}}
  </div>
</template> satisfies TOC<Signature>;
